import React, { useState } from 'react';
import { PiCaretRightBold } from 'react-icons/pi';
import css from '../../styles/modules/common/expandablesections.module.css';

export default function ExpandableSections({
  caretSelector,
  descriptionStyle,
  description,
  CustomComponent,
  details,
  caretWidth,
  caretHeight,
  caretColor,
  width,
  height,
  backgroundColor,
  customStyle,
}) {
  const [open, setOpen] = useState(true);
  function rotateCaret() {
    setOpen(() => !open);
  }

  const caretStyle = {
    marginRight: '5%',
    width: caretWidth,
    height: caretHeight,
    color: caretColor,
    transform: open ? 'rotate(90deg)' : 'none',
    transition: 'transform 0.3s ease',
  };

  return (
    <div className={css.wrapper}>
      <div
        style={{ width, height, backgroundColor, ...customStyle }}
        className={css.subWrapper}
      >
        <h5 style={{ ...descriptionStyle }}>{description}</h5>
        <PiCaretRightBold
          id={caretSelector}
          onClick={rotateCaret}
          style={caretStyle}
        />
      </div>
      {open ? <CustomComponent /> : null}
    </div>
  );
}
